const PABS_FEATURES = [
  {
    id: 'pulse_view',
    label: 'Pulse',
    description: 'Automated strategy reviews on your schedule. Set when PABS proactively reviews your plan, daily, weekly, or monthly, and get a focused summary of what changed, what stalled, and what needs a decision, delivered to your inbox.',
  },
  {
    id: 'strategy_generation',
    label: 'Design Strategy',
    description: 'AI-generated strategic analysis including design vision, themes, and opportunities.',
  },
  {
    id: 'competitor_analysis',
    label: 'Competitor Analysis',
    description: 'AI-powered competitive UX positioning and market intelligence.',
  },
  {
    id: 'share_collaborate',
    label: 'Share & Collaborate',
    description: 'Share read-only plan views with team members and clients via secure links.',
  },
  {
    id: 'mcp_integration',
    label: 'MCP Integration',
    description: 'Connect your PABS strategy to AI builder tools like Replit, Lovable, Cursor, and Claude Code. These tools consult your strategy in real time and can submit what they observe back as learnings for you to review.',
  },
  {
    id: 'pabs_chat',
    label: 'PABS Chat Assistant',
    description: 'Multi-agent orchestration for complex questions. Conversations can be scanned for learnings and evaluated against your strategy, turning chat into a decision-making moment.',
  },
  {
    id: 'brief_builder',
    label: 'Brief Builder',
    description: 'Structured brief creation with goal, problem, target audience, objectives, and deliverables.',
  },
  {
    id: 'action_plan',
    label: 'Action Plan / Gantt',
    description: 'Visual project planning with timeline, stages, tools, and drag-and-drop scheduling.',
  },
  {
    id: 'export_readme',
    label: 'Export & Documentation',
    description: 'Generate shareable PRDs, SOWs, Venture Briefs, and other documents from the live plan context.',
  },
  {
    id: 'strategic_guidance',
    label: 'Strategic Guidance',
    description: 'Strategy Ladder framework directing users to Discovery, Definition, or Delivery features.',
  },
  {
    id: 'audience_insights',
    label: 'Audience Insights',
    description: 'AI-generated audience analysis and persona understanding for the plan.',
  },
  {
    id: 'learnings_engine',
    label: 'Learnings Engine',
    description: 'Submit real-world observations, or let connected AI tools submit them via MCP. PABS evaluates each learning against the live strategy and proposes targeted changes. The user decides what gets applied.',
  },
  {
    id: 'jobs',
    label: 'Jobs',
    description: 'PABS can run tasks directly. Research, competitor summaries, drafts, and reports are executed against the actual plan context, not from scratch. Results come back ready to review and can feed back into the strategy.',
  },
];

function normalizeFeatureName(value = '') {
  return String(value).toLowerCase().replace(/[_&/]+/g, ' ').replace(/\s+/g, ' ').trim();
}

function findPilotFeature(value) {
  const normalized = normalizeFeatureName(value);
  if (!normalized) return null;

  return PABS_FEATURES.find((feature) => {
    const label = normalizeFeatureName(feature.label);
    const id = normalizeFeatureName(feature.id);
    return (
      label === normalized ||
      id === normalized ||
      label.includes(normalized) ||
      normalized.includes(label) ||
      id.includes(normalized)
    );
  }) || null;
}

function getPilotFeatureMetadata(values = []) {
  const seen = new Set();
  return values
    .map((value) => findPilotFeature(value) || { id: normalizeFeatureName(value), label: value, description: '' })
    .filter((feature) => {
      const key = feature.id || feature.label;
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
}

module.exports = {
  PABS_FEATURES,
  findPilotFeature,
  getPilotFeatureMetadata,
};
